import React from "react";

export const Logout = ({ prop }) => {
    return (
        <></>
    );
};
